import { getAHRISystemToolAttribute } from "@crescentParts/Services/AHRISystemToolService";
import { AHRIAttributeModel, AHRISystemToolAttributeModel } from "@crescentParts/Widgets/CustomApiModels";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";

type Parameter = HasOnSuccess<AHRISystemToolAttributeModel>;

export interface AHRIAttributeParameter extends Parameter {
    filterAttributes?: AHRIAttributeModel
}
type Props = {
    apiResult: AHRISystemToolAttributeModel;
};

type HandlerType = ApiHandlerDiscreteParameter<AHRIAttributeParameter, Props, AHRISystemToolAttributeModel>

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = await getAHRISystemToolAttribute(props.parameter.filterAttributes);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [ SendDataToApi, ExecuteOnSuccessCallback];

const getAHRISystemToolHandlerAttribute = createHandlerChainRunner(chain, "getAHRISystemToolHandlerAttribute");
export default getAHRISystemToolHandlerAttribute;
